export function isJsonValid(json: string | undefined): boolean {
	try {
		if (!json) return false
		else JSON.parse(json)
		return true
	} catch (e) {
		return false
	}
}
